// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IQruD","colBig":"styles_colBig__3ds2Y","colSmall":"styles_colSmall__CZ-wi","shopifyNameWrapper":"styles_shopifyNameWrapper__29E3w"};